import main from "../../assets/img/lime/lime.png"

export default function Lime() {
    return (
        <main className="portfolioDetail">
            <h1>Lime - Brand Design</h1>
            <img src={main} alt="project information" loading="lazy" />
        </main>
    );
  }